import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})

export class SignUpComponent {

  public show: boolean = true;
  public finished: boolean = false;
  public loginForm: FormGroup;
  public isLoading:boolean = false;
  public currentStep: number = 1;
  public progressPercentage: number = 20;

    // Títulos e descrições das etapas
    public stepTitles: string[] = [
      'Vamos começar!',
      'Quem é você?',
      'Nos fale sobre sua empresa.',
      'Qual é o seu número de telefone?',
      'Crie uma senha segura.',
    ];
  
    public stepDescriptions: string[] = [
      'Informe o seu email para começarmos o cadastro.',
      'Digite o seu nome completo para personalizar sua experiência.',
      'Nos diga o nome da sua empresa para podermos ajudá-lo melhor.',
      'Precisamos do seu número para contato e verificação.',
      'Defina uma senha forte para proteger sua conta.',
    ];


constructor(private fb: FormBuilder,  public router: Router, private http: HttpClient, private toastr: ToastrService) {
  // const userData = localStorage.getItem('token');

  //   if(userData?.length != null){
  //     router.navigate(['/dashboard/default'])
  //   }

  this.loginForm = this.fb.group({
    senha: ["", Validators.required],
    nomeUsuario: ["", Validators.required],
    ddd: ["", [Validators.pattern('^[0-9]*$')]],
    telefone: ["", [Validators.pattern('^[0-9]*$')]],
    nomeEstabelecimento: ["", Validators.required],
    emailComercial: ["", [Validators.required, Validators.email]]
  });
}

nextStep() {
  if (this.currentStep < 5) {
    this.currentStep++;
    this.progressPercentage = (this.currentStep / 5) * 100;
  }
}

previousStep() {
  if (this.currentStep > 1) {
    this.currentStep--;
    this.progressPercentage = (this.currentStep / 5) * 100;
  }
}

  create() {

      // Mapeia os dados do formulário para o formato esperado pela API
  const payload = {
    empresa: this.loginForm.get('nomeEstabelecimento')?.value,
    email: this.loginForm.get('emailComercial')?.value,
    nome: this.loginForm.get('nomeUsuario')?.value,
    senha: this.loginForm.get('senha')?.value,
    ddd: this.loginForm.get('ddd')?.value,
    telefone: this.loginForm.get('telefone')?.value,
  };

     this.isLoading = true;
      this.http.post<any>(`${environment.apiUrl}/signup/pre`,  payload ).subscribe(
        (response) => {
          console.log(response);
         
          this.finished = true
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error('Error:', error);
        });
    };





}
